<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <v-btn @click="dialog = false" absolute right class="mt-3" icon>
        <v-icon>fas fa-times</v-icon>
      </v-btn>
      <div class="px-6 py-4">
        <h4>Закрыть кредит</h4>
      </div>
      <v-card-text>
        <template v-if="!message">
          <validation-observer v-slot="{handleSubmit}" ref="formObserver">
            <form @submit.prevent="handleSubmit(submit)">
              <custom-select
                  rules="required"
                  v-model="creditInfo.type"
                  :items="CREDIT_PAYMENT_TYPES"
                  label="Тип платежа"
                  item-value="value"
                  item-text="text"
              ></custom-select>
              <custom-input-text
                  :value="creditInfo.all|money"
                  label="Сумма"
                  disabled
              ></custom-input-text>
              <template v-if="creditInfo">
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-space-between">
                    <span>Основная сумма</span> <span>{{ creditInfo.main|money }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-space-between">
                    <span>Процент</span> <span>{{ creditInfo.percent }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-space-between">
                    <span>Общая сумма к оплате</span> <span>{{ creditInfo.all|money }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <div class="text-right mt-3">
                <v-btn class="mr-3" color="error" @click="dialog = false">Закрыть</v-btn>
                <v-btn color="primary" type="submit">Принять</v-btn>
              </div>
            </form>
          </validation-observer>
        </template>
        <h4 v-else>{{ message }}</h4>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>

import {CREDIT_PAYMENT_TYPES, messages} from "@/utils/constants"

const DEFAULT_CREDIT_INFO = {
  type: null,
  all: null,
  main: null,
  percent: 0
}

export default {
  name: 'CloseCreditDialog',
  props: {
    credit_id: {
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      creditInfo: {
        ...DEFAULT_CREDIT_INFO
      },
      message: null,
    }
  },
  methods: {
    checkCredit() {
      return this.$http.get(`admin/credit/early-finish/${this.credit_id}`).then(({data: {data}}) => {
        if (data.all === 0) {
          this.message = 'Кредит погашен, долга нет'
        } else {
          this.creditInfo = data
        }
      })
    },
    async show() {
      this.$showLoading()
      try {
        await this.checkCredit()
        this.dialog = true
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async submit() {
      this.$showLoading()
      try {
        await this.$http.post('admin/credit/transaction-early-finish', {
          credit_id: this.credit_id,
          type: this.creditInfo.type,
          amount: this.creditInfo.all
        })
        this.dialog = false
        this.$emit('saved')
        this.$setSuccess({text: messages.onCloseCredit})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    clear() {
      const {formObserver} = this.$refs
      this.message = null
      this.creditInfo = {...DEFAULT_CREDIT_INFO}
      if (formObserver) formObserver.reset()
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.clear()
      }
    }
  },
  computed: {
    CREDIT_PAYMENT_TYPES() {
      return CREDIT_PAYMENT_TYPES.filter(item => item.value !== 'card')
    }
  }
}
</script>